import { MetricKpiCard } from "@/features/dashboard/shell";
import { OverviewSection } from "@/features/dashboard/hub/OverviewSection";

import { MOCK_USERS_BY_TYPE, MOCK_USERS_REGISTERED_TODAY } from "./mock-data";

/**
 * Overview mock de usuarios por tipo.
 */
export function UsersOverview(): React.JSX.Element {
  return (
    <OverviewSection
      title="Usuarios"
      description={`${MOCK_USERS_REGISTERED_TODAY} registros hoy · totales por tipo (mock)`}
      isMock
    >
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {MOCK_USERS_BY_TYPE.map((u) => (
          <MetricKpiCard
            key={u.type}
            label={u.label}
            value={u.count.toLocaleString("es")}
            hint="Total registrados (mock)"
          />
        ))}
      </div>
    </OverviewSection>
  );
}
